import {
    ServerCIEnvironment,
    ServerEnvironment,
    type ServerBaseUrl
} from '~/servers/types';

/**
 * Server configuration for the DHL UAT environment (`admin.dhl-uat.wisesys.info`)
 */
export const dhlUatServerConfig: ServerBaseUrl = {
    apiServer: 'https://wise-api.dhl-uat.wisesys.info',
    auroraApiServer: 'https://uat.aurora-v2.wisesys.info',
    initialVsActualServer:
        'https://g9ezx7baqc.execute-api.us-east-2.amazonaws.com/uat',
    socketServer: 'wss://socket.dhl-uat.wisesys.info',
    environment: ServerEnvironment.DHL_UAT,
    CIEnv: ServerCIEnvironment.DHL_UAT,
    auroraServer: '',
    vehicleProfile:
        'https://z9fgl5xulh.execute-api.us-east-1.amazonaws.com/uat',
    routePathGeometryServer:
        'https://u0dlfowfi9.execute-api.us-east-1.amazonaws.com/uat',
    configurableWorkflowServer:
        'https://ksjgorzu2k.execute-api.us-east-1.amazonaws.com/Prod',
    driverCostServer: '' // TODO(CD-112): regional UAT — needs its own dcs-<region> stack (separate Cognito issuer)
};
